















// 3rd party libs
import Vue from 'vue';
import {
    mapGetters,
} from 'vuex';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';

const IFRAME_MOBILE_SIZE = {
    width: '100%',
    height: 550,
};
const IFRAME_SIZES = [
    {
        width: 900,
        height: 710,
    },
    {
        width: 640,
        height: 660,
    },
    {
        width: 560,
        height: 600,
    },
    {
        width: 480,
        height: 535,
    },
];

export default Vue.extend({
    components: {
        loadingSpinner,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        onCancel: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isIframeSizeSet: false,
            iframeSize: false,
        };
    },
    computed: {
        ...mapGetters(['isMobileDevice']),
    },
    created() {
        window.addEventListener('message', this.onResult);

        if (this.isMobileDevice) {
            this.iframeSize = {
                width: IFRAME_MOBILE_SIZE.width,
                height: window.innerHeight - 150,
            };
            this.isIframeSizeAlreadySet = true;

            return;
        }

        const iframeWrapperWidth = this.$refs.ukQuizIframe?.clientWidth || 650;

        this.iframeSize = IFRAME_SIZES.find((size) => size.width <= iframeWrapperWidth) ||
            IFRAME_SIZES[3];
        this.isIframeSizeAlreadySet = true;
    },
    destroyed() {
        window.removeEventListener('message', this.onResult);
    },
    methods: {
        onResult(ev: MessageEvent) {
            if (ev?.data?.type === 'ukQuizResult') {
                this.$emit('submit', {});
            }
        },
    },
});
